import { render, staticRenderFns } from "./PriceNormalizer.vue?vue&type=template&id=52f9a60c&lang=pug&"
import script from "./PriceNormalizer.vue?vue&type=script&lang=js&"
export * from "./PriceNormalizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports